import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Component({
    selector: 'tidy-active-button',
    styleUrls: ['./tidy-active-button.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
    <button  expand="block" [disabled]="disabled || loading" [ngClass]="color"  tappable (click)="executeAction()" type="submit" block>
      <span>{{text}}</span>
      @if (loading) {
        <ion-spinner></ion-spinner>
      }
    </button>
    `,
    standalone: false
})
export class TidyActiveButtonComponent {

    @Input() text: string;
    @Input() color = 'tidy_green';
    @Input() action: () => Promise<any>;
    @Input() disabled = false;

    loading = false;

    constructor(
      private toastCtrl: ToastController
    ) { }

    executeAction = async () => {
      this.loading = true;
      try {
        await this.action();
        this.loading = false;
      } catch (error) {
        this.showError(error);
        this.loading = false;
      }
    }

    async showError(message) {
      (await this.toastCtrl.create({ message, duration: 3000 })).present();
    }

}
